import * as Yup from 'yup';


const preferredPartnerContentSchema = Yup.object().shape({
    title: Yup.string().required('Title is required.'),
    services: Yup.string().required('Services is required.'),
    description: Yup.string().required('Description is required.'),
});
export default preferredPartnerContentSchema;
